module.exports = __webpack_public_path__ + "static/media/padlehuk_skarvoy.4b708340.png";